import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

import { currency } from 'Helpers/Formats';

import HomeIcon from '@material-ui/icons/Home';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PaymentIcon from '@material-ui/icons/Payment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.facet.primaryBlue,
  },
  iconWrapper: {
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.radius.xl,
    marginRight: theme.spacing(2),
  },
});

const Header = ({
  className,
  classes,
  sectionResource,
}) => {
  // TODO: Get these Icons from the server
  const ICONS = {
    realAssets: <HomeIcon className={classes.icon} />,
    investable: <TrendingUpIcon className={classes.icon} />,
    cash: <AttachMoneyIcon className={classes.icon} />,
    creditCards: <PaymentIcon className={classes.icon} />,
    property: <HomeIcon className={classes.icon} />,
    otherLoans: <AccountBalanceIcon className={classes.icon} />,
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.titleWrapper}>
        {/* --- TODO: ADD ICON HERE (NEED URL FROM SERVER) --- */}
        <div className={classes.iconWrapper}>
          {sectionResource && ICONS[sectionResource?.resourceType]}
        </div>
        <Typography
          className={classes.title}
          color={'primary'}
          variant={'h5'}
          weight={'bold'}
        >
          {sectionResource.attr('title')}
        </Typography>
      </div>
      <Typography
        className={classes.title}
        color={'primary'}
        variant={'h5'}
        weight={'medium'}
        test={'balance-sheet-section-balance'}
      >
        {currency(sectionResource.attr('total'), true)}
      </Typography>
    </Box>
  );
};

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  sectionResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
